export enum Systems {
    AZURE = 'azure',
    DEV_FACTORY = 'devFactory',
    SKE = 'SKE',
}
